__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/1fd545a/_next/";